import { Grid } from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { CornermarkDetailsFragment } from "@saleor/fragments/types/CornermarkDetailsFragment";
import { CornermarkErrorFragment } from "@saleor/fragments/types/CornermarkErrorFragment";
import { sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { CornerMarkTypeEnum } from "@saleor/types/globalTypes";
import { concat } from "lodash-es";
import React from "react";
import { useIntl } from "react-intl";

import CornermarkDetails from "../CornermarkDetails/CornermarkDetails";
import { CornermarkPageFormData } from "../CornermarkPage";

export interface CornermarkAddPageProps {
  cornermark: CornermarkDetailsFragment | null;
  disabled: boolean;
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  onDelete: () => void;
  onSubmit: (data: CornermarkPageFormData) => void;
  errors: CornermarkErrorFragment[];
  title: string;
}

const CornermarkAddPage: React.FC<CornermarkAddPageProps> = ({
  cornermark,
  disabled,
  errors,
  saveButtonBarState,
  onBack,
  onDelete,
  onSubmit,
  title
}) => {
  const intl = useIntl();
  const initialForm: CornermarkPageFormData =
    cornermark === null
      ? {
          title: "",
          textColor: "",
          type: CornerMarkTypeEnum.NORMAL,
          mainColor: "",
          secondaryColor: ""
        }
      : {
          title: maybe(() => cornermark.titleText, ""),
          textColor: maybe(() => cornermark.textColor, ""),
          type: maybe(() => cornermark.type, CornerMarkTypeEnum.NORMAL),
          mainColor: maybe(() => cornermark.mainColor, ""),
          secondaryColor: maybe(() => cornermark.secondaryColor, "")
        };

  const handleSubmit = (data: CornermarkPageFormData) =>
    onSubmit({
      ...data
    });

  return (
    <Form initial={initialForm} onSubmit={handleSubmit}>
      {({ change, data, hasChanged, submit }) => (
        <Container>
          <AppHeader onBack={onBack}>
            {intl.formatMessage(sectionNames.cornermarks)}
          </AppHeader>
          <PageHeader
            title={
              cornermark === null
                ? intl.formatMessage({
                    defaultMessage: "Create New Cornermark",
                    description: "create new cornermark"
                  })
                : maybe(() => concat(cornermark.titleText, " Title"))
            }
          />
          <Grid>
            <div>
              <CornermarkDetails
                errors={errors}
                data={data}
                disabled={disabled}
                onChange={change}
                title={title}
              />
            </div>
          </Grid>
          <SaveButtonBar
            disabled={disabled || !hasChanged}
            state={saveButtonBarState}
            onCancel={onBack}
            onSave={submit}
            onDelete={cornermark === null ? undefined : onDelete}
          />
        </Container>
      )}
    </Form>
  );
};
export default CornermarkAddPage;
